import styled from 'styled-components';
import { Text, Button, Label } from '@cashfree-intl/coherent';
import { Image } from 'components/Image';

export const StyledPitchPageContainer = styled.div`
  background-color: #230350;
  border-radius: 1rem;
  color: white;
  position: relative;
  overflow: hidden;
`;

export const StyledPitchPageHeading = styled(Text)`
  margin: 0.75rem 0;
`;

export const StyledPitchMetaHeading = styled(Text)`
  margin-bottom: 1.125rem;
`;

export const StyledBannerText = styled(Text)`
  max-width: 50%;
`;

export const StyledNewBannerText = styled(Text)`
  max-width: 80%;
`;

export const StyledPitchMetaContent = styled.div`
  max-width: 30rem;
  .meta-data-content {
    margin-left: 1.375rem;
    margin-top: 0.375rem;
  }
`;

export const StyledSecondaryButton = styled(Button)`
  border-color: white !important;
  color: white;
  &:hover {
    background-color: unset !important;
  }
`;

export const StyledIllustrationImg = styled(Image)`
  position: absolute;
  top: 4rem;
  left: 30%;
  @media (min-width: 1300px) {
    left: unset;
    right: 0;
  }
`;

export const StyledBannerIllustrationImg = styled(Image)`
  position: absolute;
  bottom: 0;
  left: 50%;
  @media (min-width: 1300px) {
    left: unset;
    right: 0;
  }
`;

export const StyledNewBannerIllustrationImg = styled(Image)`
  position: absolute;
  bottom: 0;
  left: 50%;
  @media (min-width: 1300px) {
    left: unset;
    right: 0;
    top: 1rem;
  }
`;

export const StyledLabel = styled(Label)`
  &.waitlisted-label {
    background-color: #35036d;
    color: #efe5ff;
  }
`;

export const StyledActionWrapper = styled.div`
  position: relative;
  z-index: 1;
`;
